<template>
  <div class="doorpostdescribe">
    <div class="header">
      <div class="title">可靠的智慧防疫软件</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div
          class="item"
          v-for="item in list"
          :key="item.id"
          :style="item.id != 1 ? 'padding-top: 40px' : ''"
        >
          <div v-if="item.id == 1">
            <img
              style="width: 80px"
              v-for="(it, index) in item.logo"
              :key="index"
              :src="it"
              alt=""
            />
          </div>
          <div v-else>
            <img style="width: 175px" :src="item.logo" alt="" />
          </div>
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import EBSoftware1 from "../../../../assets/programme/EBSoftware1.png";
import EBSoftware2 from "../../../../assets/programme/EBSoftware2.png";
import EBSoftware3 from "../../../../assets/programme/EBSoftware3.png";
import EBSoftware4 from "../../../../assets/programme/EBSoftware4.png";
import EBSoftware5 from "../../../../assets/programme/EBSoftware5.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          logo: [EBSoftware1, EBSoftware2],
          title: "智慧防疫手机端",
          text: "智慧防疫APP包含场所巡防、防疫人员信息采集、健康信息上报等功能，方便居委和物业快速统计信息，了解防控人员的实时情况。",
        },
        {
          id: 2,
          logo: EBSoftware3,
          title: "智慧防疫管理后台",
          text: "利用工程师自主建立的数据表格提供精确的计算方法，分析疫情并计算和疫情相关的所有重要数据。数据实时更新，帮助物业和居委方便快捷的了解所有住户情况。",
        },
        {
          id: 3,
          logo: EBSoftware4,
          title: "健康数据可视化",
          text: "防控人员信息档案快速录入并提供健康数据信息报表统计、可进行查询、新增等管理功能，帮助物业和居委快速登记信息，实现信息化管理。",
        },
        {
          id: 4,
          logo: EBSoftware5,
          title: "异常报警处理",
          text: "平台提供异常数据，包括体温异常、重点人员隔离越界、隔离人员外出等异常报警。异常事件全程监控记录，进行可视化流程管理。",
        },
      ],
    });
  },
};
</script>

<style scoped>
.doorpostdescribe {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body .list {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  margin-bottom: 40px;
}
.body .list .item {
  padding: 20px;
  background: linear-gradient(153deg, #eff7ff 0%, #fdfeff 100%);
  border: 1px solid rgba(0, 0, 0, 0.06);
  text-align: center;
}
.body .list .item .title {
  font-size: 18px;
  text-align: left;
  margin-top: 30px;
}
.body .list .item .text {
  margin-top: 20px;
  font-size: 14px;
  color: #495a6c;
  text-align: left;
}
</style>
